import { jwtDecode } from "jwt-decode";
import HmacSHA256 from "crypto-js/hmac-sha256";
import Hex from "crypto-js/enc-hex";

const SECRET_KEY = "DPOD_AMEYA_2.0_AUTH_KEY";

export const formatLabel = (label) => {
    if (typeof label !== 'string') return '';
    return label.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

export const checkProject = async (project_id) => {
    try {
        const service_token = JSON.parse(localStorage.getItem('service-agent-user-token')) ?? null;
        if (service_token) {
            const token = jwtDecode(service_token);
            const token_project_id = token?.project_id ?? null;
            if (token_project_id === project_id) {
                return;
            } else {
                localStorage.removeItem("service-agent-user-token")
                localStorage.removeItem("agent-user-token")
                localStorage.removeItem("analytics_base_url")
            }
            return
        }
        return
    } catch (error) {
        console.log(error)
    }
}

export function decodeParamToken(fileId, documentType) {
    const data = `${fileId}${documentType}`;
    const token = HmacSHA256(data, SECRET_KEY).toString(Hex);
    return token;
}

export async function lowercaseStrings(jsonInput) {
    const processValue = (value) => {
        if (typeof value === 'string') {
            return value.toLowerCase();
        }
        if (Array.isArray(value)) {
            return value.map(item => processValue(item));
        }
        if (typeof value === 'object' && value !== null) {
            return processObject(value);
        }
        return value;
    };

    const processObject = (obj) => {
        const result = {};
        for (const key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                result[key] = processValue(obj[key]);
            }
        }
        return result;
    };

    return processObject(jsonInput);
}

export const UTIL_CONFIG = {
    EXT_USER_TYPE: "external_appflyte_user",
    STRIPE_REQUEST: "external_stripe",
    USER_REQUEST: "external_user",
    SUPPORTED_SERVICES: ["ddl", "dml"],
    SUPPORTED_BILLING_PERIODS: ["monthly", "yearly"],
    DDL_SERVICE: "ddl",
    DML_SERVICE: "dml",

    AUTH_TYPE: "external_auth",
    EXT_USER_SIGNIN: "ext_user_signin",
    EXT_USER_SIGNUP: "ext_user_signup",
    EXTERNAL_APPFLYTE_AUTH: "external_appflyte_auth",
    EXTERNAL_APPFLYTE_USER: "external_appflyte_user",
    EXTERNAL_APPFLYTE_STRIPE: "external_appflyte_stripe",
    EXT_USER: "external_user",
    DIRECT_USER: "direct_user",
    APPFLYTE_AGENT: "appflyte_agent",
    SERVICE_DDL: "ddl",

    PLAN_TYPE_PRO: "pro",
    PLAN_TYPE_FREE: "free",
    FREE_PLAN_PROJECT_LIMIT: 1
};

export const getColorFromString = (str) => {
    const colors = ['#EFF6FF', '#FEF3C7', '#DCFCE7', '#FEE2E2', '#E0E7FF', '#FCE7F3'];
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
};

const STANDARD_INSTANCE = "standard"
const APPFLYTE_COMMUNITY_INSTANCE = "appflyte_community"
const APPFLYTE_AWS_MARKET_PLACE_INSTANCE = "appflyte_aws_marketplace"

export const DEPLOYMENT_MODE = window.__ENV__.DEPLOYMENT_MODE || STANDARD_INSTANCE;
export const IS_COMMUNITY_MODE = DEPLOYMENT_MODE === APPFLYTE_COMMUNITY_INSTANCE;
export const IS_AWS_MODE = DEPLOYMENT_MODE === APPFLYTE_AWS_MARKET_PLACE_INSTANCE;
export const LOCAL_TESTING_ENABLED = window.__ENV__.LOCAL_TESTING_ENABLED === "true" || false;